// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__-FKQ3","range":"MonthRangeSwitch_range__2Y7Jn","disabled":"MonthRangeSwitch_disabled__3HDxy"};